/**
 * Native-only hook.
 */
export const useQuickActions = () => {};
